// extracted by mini-css-extract-plugin
export default {"import":"BatchEdge_import__2GAUM"};